/* Album step 1: existing size and paper choices, before photo upload. */
(() => {
"use strict";
if(window.__cwAlbumFirstStep2026)return;
window.__cwAlbumFirstStep2026=true;
const root=document.querySelector("[data-book-shop]");
if(!root)return;
const qs=s=>root.querySelector(s);
let selectSize,selectPaper,types,panel,message,installed=false;
function el(tag,className,text){
  const e=document.createElement(tag);
  if(className)e.className=className;
  if(text!==undefined)e.textContent=text;
  return e;
}
function format(text){
  const m=String(text).match(/(\d+(?:\.\d+)?)\s*(?:in(?:ches)?)?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
  if(!m)return null;
  const w=Number(m[1]),h=Number(m[2]);
  if(!w||!h)return null;
  return Math.abs(w-h)/Math.max(w,h)<0.07?"square":w>h?"landscape":"portrait";
}
function options(source){return [...source.options].map(o=>({value:o.value,label:o.textContent.trim()}))}
function fill(select,items){
  if(select.options.length===items.length&&items.every((o,i)=>select.options[i].value===o.value&&select.options[i].textContent===o.label))return;
  select.replaceChildren(...items.map(o=>new Option(o.label,o.value)));
}
function sync(){
  if(!installed)return;
  const size=qs("[data-size]"),paper=qs("[data-paper]");
  if(!size||!paper||!size.options.length)return;
  const opts=options(size);
  fill(selectSize,opts);
  fill(selectPaper,options(paper));
  selectSize.value=size.value;selectPaper.value=paper.value;
  types.replaceChildren();
  const available=[...new Set(opts.map(o=>format(o.label)).filter(Boolean))];
  if(available.length>1){
    available.forEach(kind=>{
      const b=el("button","cw-album-size-chip",kind.charAt(0).toUpperCase()+kind.slice(1));
      b.type="button";
      const selected=opts.find(o=>o.value===size.value);
      b.setAttribute("aria-pressed",String(selected&&format(selected.label)===kind));
      b.addEventListener("click",()=>{
        const found=opts.find(o=>format(o.label)===kind);
        if(found)change(size,found.value);
      });
      types.append(b);
    });
    message.textContent="Choose from the album shapes currently available.";
  }else{
    message.textContent=available.length?"Available orientation: "+available[0]+".":"Choose from the sizes currently available.";
  }
}
function change(source,value){
  if(!source||source.value===value)return;
  source.value=value;
  source.dispatchEvent(new Event("change",{bubbles:true}));
  const count=qs("[data-plan-number]");
  if(count)count.dispatchEvent(new Event("input",{bubbles:true}));
  sync();
}
function setup(){
  if(installed){sync();return;}
  const stage=qs('[data-stage="1"]'),size=qs("[data-size]"),paper=qs("[data-paper]");
  if(!stage||!size||!paper||!size.options.length)return;
  panel=el("section","cw-album-stage-options");
  panel.setAttribute("data-cw-album-stage-options","");
  panel.append(el("h3","","Album Size & Paper"));
  const labelSize=el("label","cw-album-first-label","Album size");
  selectSize=el("select","cw-album-first-select");selectSize.setAttribute("aria-label","Album size");
  labelSize.append(selectSize);panel.append(labelSize);
  panel.append(el("p","cw-album-first-legend","Album orientation"));
  types=el("div","cw-album-first-types");panel.append(types);
  const labelPaper=el("label","cw-album-first-label","Inside paper");
  selectPaper=el("select","cw-album-first-select");selectPaper.setAttribute("aria-label","Inside paper");
  labelPaper.append(selectPaper);panel.append(labelPaper);
  message=el("p","cw-album-first-note");panel.append(message);
  const before=stage.querySelector(".cwb-plan-price");
  if(before)before.before(panel);else stage.append(panel);
  installed=true;
  selectSize.addEventListener("change",()=>change(size,selectSize.value));
  selectPaper.addEventListener("change",()=>change(paper,selectPaper.value));
  size.addEventListener("change",sync);
  paper.addEventListener("change",sync);
  new MutationObserver(sync).observe(size,{childList:true});
  sync();
}
root.addEventListener("click",e=>{
  if(e.target.closest("[data-start], [data-stage-link='1'], [data-wizard-back]")){
    requestAnimationFrame(setup);
  }
},true);
setup();
})();